import Vue from 'vue'
// import {ValidationProvider} from 'vee-validate/dist/vee-validate.full.esm'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/plugins/veeValidate/validators.js'

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
